export default __webpack_public_path__ + "static/media/third-left.3d7b3df6.png";